<template>
  <li v-if="isVisible" class="nav-group" :class="`${toggled ? 'opened-dropdown': 'closed-dropdown'}`">
    <button class="nav-group-title" aria-label="Toggle dropdown" title="Toggle dropdown" @click="toggled = !toggled">
      <i class="k-asset-icon fa-duotone fa-magnifying-glass-chart"></i>
      <span v-if="otjsToReview && !isSidebarOpen && (isLearnerSupport || hasOtjPermissions)" class="count-bubble collapsed-count-bubble" title="Pending OTJs count">{{ otjsToReview }}</span>
      <span class="nav-group-title-text">Monitor</span>
      <span v-if="otjsToReview && (isLearnerSupport || hasOtjPermissions)" class="count-bubble" title="Pending OTJs count">{{ otjsToReview }}</span>
      <i class="fas fa-angle-down"></i>
    </button>
    <ul class="second-level">
      <li v-if="hasMonitorProgrammes" class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{  name: 'monitor_programme_summary'}">
            <span>Programme Summary</span>
          </router-link>
        </div>
      </li>
      <li v-if="hasMonitorProgrammes" class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{ name: 'monitor_learner_progress' }">
            <span>Learner Progress</span>
          </router-link>
        </div>
      </li>
      <li v-if="$featureFlags.isEnabled('kate-meeting-forms')" class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{ name: 'meetings_inbox' }">
            <span>Meetings Inbox</span>
          </router-link>
        </div>
      </li>
      <li v-if="isLearnerSupport || hasOtjPermissions" class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{ name: 'otj_inbox' }">
            <span>O.T.J. Inbox</span>
          </router-link>
          <span v-if="otjsToReview" class="count-bubble">{{ otjsToReview }}</span>
        </div>
      </li>
      <li v-if="isLearnerSupport && this.$featureFlags.isEnabled('kate-projects-dashboard')" class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{ name: 'project_inbox' }">
            <span>Project Inbox</span>
          </router-link>
        </div>
      </li>
      <li v-if="hasViewEmployerLearners" class="nav-sub-group">
        <div class="nav-sub-group-title">
          <router-link :to="{ name: 'employer_learner_summary' }">
            <span>Employer Summary</span>
          </router-link>
        </div>
      </li>
    </ul>
  </li>
</template>

<style>
/* == Monitor Count Bubble == */
.sidebar-panel.collapsed .count-bubble.collapsed-count-bubble {
  position: absolute;
  right: 0;
  bottom: 0;
}

.sidebar-panel.collapsed:hover .count-bubble.collapsed-count-bubble {
  display: none;
}

</style>

<style scoped>
.count-bubble {
  flex: none;
  margin: 0;
}

.nav-sub-group-title .count-bubble {
  margin: 0 15px 0 5px;
}
</style>

<script>
import useGlobalStore from '@stores/global';
import SidebarEntryMixin from '@mixins/sidebar-entry-mixin';
import SidebarMixin from '@mixins/sidebar-mixin';

export default {
  mixins: [SidebarEntryMixin, SidebarMixin],

  data() {
    return {
      store: useGlobalStore(),
      toggled: false,
      pendingOtjsReady: false,
    };
  },

  beforeMount() {
    this.getPendingOtjs();
    this.$sidebar.setRefreshOtjsCallback(this.getPendingOtjs);
  },

  watch: {
    route() {
      this.getPendingOtjs();
    },
  },

  computed: {
    route() {
      return this.$route;
    },
    hasMonitorProgrammes() {
      return this.$permissions.hasPermission('monitor_programmes');
    },
    hasViewEmployerLearners() {
      return this.$permissions.hasPermission('view_employer_learners');
    },
    hasOtjPermissions() {
      return this.$permissions.hasPermission('view_user_otjs');
    },
    isVisible() {
      return this.hasMonitorProgrammes || this.hasViewEmployerLearners;
    },
    coachUserId() {
      return this.store.userId;
    },

    isSidebarOpen() {
      return this.store.isSidebarOpen;
    },

    isLearnerSupport() {
      return Boolean(this.store.learnerSupportType);
    },
  },

  methods: {
    getPendingOtjs() {
      this.pendingOtjsReady = false;
      this.$logger.info('Fetching pending OTJs', { coachUserId: this.coachUserId });
      this.$http.get(`/api/curriculum/admin/programmes/otj-entries/${this.coachUserId}`)
        .then(response => {
          this.$logger.info('Successfully fetched pending OTJs', { coachUserId: this.coachUserId });
          const totalPendingOtjs = response.data.reduce((total, learner) => total + learner.pending_otj_count, 0);
          this.$sidebar.otjsToReview = totalPendingOtjs;
        })
        .catch(error => {
          this.$logger.error('Error fetching pending OTJs', { coachUserId: this.coachUserId }, error);
        }).then(() => {
          this.pendingOtjsReady = true;
        });
    },
  },
};
</script>
